define(
	'Paystand.PaystandExtensionV2.Loader'
,	[
	]
,	function ()
{
	'use strict';

	var LOADER_TOAST_TITLE = 'Paystand connection issue';
	var LOADER_TOAST_MESSAGE = 'We could not connect to Paystand right now. Please refresh the page. If the problem continues, contact Paystand support.';

	return {
		mountToApp: function mountToApp (container)
		{
			var environment = null;
			var userProfile = null;
			var serviceBaseUrl = '';
			var debug = false;
			var targetWindow = typeof window !== 'undefined' ? window : null;
			var runtimeEntrypoint = 'checkout';
			var resolverUrl = '';
			var loaderPrint = null;

			if (container && typeof container.getComponent === 'function')
			{
				try
				{
					environment = container.getComponent('Environment') || null;
				}
				catch (error)
				{
					environment = null;
				}

				try
				{
					userProfile = container.getComponent('UserProfile') || null;
				}
				catch (error)
				{
					userProfile = null;
				}
			}

			if (environment && typeof environment.getConfig === 'function')
			{
				serviceBaseUrl = environment.getConfig('Paystand.loader.metadataUrl');
				debug = environment.getConfig('Paystand.loader.debug') === true;
			}

			serviceBaseUrl = normalizeString(serviceBaseUrl);

			if (!serviceBaseUrl)
			{
				return;
			}

			if (!targetWindow || !targetWindow.document || typeof targetWindow.document.createElement !== 'function')
			{
				return;
			}

			runtimeEntrypoint = resolveCurrentEntrypoint(targetWindow, environment, serviceBaseUrl);
			resolverUrl = buildResolverUrl(serviceBaseUrl, runtimeEntrypoint, resolveCurrentDomain(targetWindow));
			loaderPrint = createLoaderPrint(targetWindow, serviceBaseUrl, runtimeEntrypoint, userProfile);

			loaderPrint.info({
				eventType: 'runtime-load-start',
				phase: 'loader',
				action: 'load-runtime',
				status: 'start',
				message: 'Loading remote runtime.',
				metadata: {
					resolverUrl: resolverUrl
				}
			});

			resolveRuntimeMetadata(targetWindow, resolverUrl, function onResolved (payload)
			{
				var resolvedEntrypoint =
					inferEntrypoint(readString(payload, 'entrypoint') || resolverUrl) || runtimeEntrypoint;
				var resolvedScriptUrl = readString(payload, 'runtime.url');

				loaderPrint.setResolvedPayload(payload);

				if (!resolvedScriptUrl)
				{
					loaderPrint.error({
						eventType: 'runtime-load-failure',
						phase: 'loader',
						action: 'resolve-runtime',
						status: 'error',
						message: LOADER_TOAST_MESSAGE,
						metadata: {
							entrypoint: resolvedEntrypoint,
							resolverUrl: resolverUrl,
							payload: payload,
							supportReason: 'Runtime resolver response did not include runtime.url.'
						}
					});
					return;
				}

				if (runtimeMatchesPayload(readRuntime(targetWindow, resolvedEntrypoint), payload))
				{
					mountRuntime(targetWindow, container, resolvedEntrypoint, resolvedScriptUrl, debug, payload, loaderPrint, serviceBaseUrl);
					return;
				}

				loadRuntimeScript(targetWindow, resolvedScriptUrl, function onLoaded ()
				{
					mountRuntime(targetWindow, container, resolvedEntrypoint, resolvedScriptUrl, debug, payload, loaderPrint, serviceBaseUrl);
				}, function onError (error)
				{
					loaderPrint.error({
						eventType: 'runtime-load-failure',
						phase: 'loader',
						action: 'script-load',
						status: 'error',
						message: LOADER_TOAST_MESSAGE,
						error: error,
						metadata: {
							entrypoint: resolvedEntrypoint,
							resolverUrl: resolverUrl,
							scriptUrl: resolvedScriptUrl,
							supportReason: 'Failed to load remote runtime script.'
						}
					});
				});
			}, function onError (error)
			{
				loaderPrint.error({
					eventType: 'runtime-load-failure',
					phase: 'loader',
					action: 'resolver-fetch',
					status: 'error',
					message: LOADER_TOAST_MESSAGE,
					error: error,
					metadata: {
						entrypoint: runtimeEntrypoint,
						resolverUrl: resolverUrl,
						supportReason: 'Failed to resolve remote runtime.'
					}
				});
			});
		}
	};

	function normalizeString (value)
	{
		return value === null || value === undefined ? '' : String(value).replace(/^\s+|\s+$/g, '');
	}

	function inferEntrypoint (value)
	{
		var normalized = normalizeString(value);
		var match = normalized.match(/\/(checkout|my-account)(?:\/|$)/i);

		if (match && match[1])
		{
			return String(match[1]).toLowerCase();
		}

		if (/my[_-]?account/i.test(normalized))
		{
			return 'my-account';
		}

		if (/checkout/i.test(normalized))
		{
			return 'checkout';
		}

		return '';
	}

	function resolveCurrentEntrypoint (targetWindow, environment, metadataUrl)
	{
		var candidates = [];
		var session = null;
		var touchpointUrl = '';
		var index = 0;
		var inferred = '';

		if (environment && typeof environment.getSession === 'function')
		{
			try
			{
				session = environment.getSession() || null;
			}
			catch (error)
			{
				session = null;
			}
		}

		touchpointUrl = readString(session, 'touchpoints.myaccount') || readString(session, 'touchpoints.checkout');

		candidates = [
			targetWindow && targetWindow.location ? targetWindow.location.pathname : '',
			targetWindow && targetWindow.location ? targetWindow.location.href : '',
			touchpointUrl,
			metadataUrl
		];

		for (index = 0; index < candidates.length; index++)
		{
			inferred = inferEntrypoint(candidates[index]);

			if (inferred)
			{
				return inferred;
			}
		}

		return 'checkout';
	}

	function resolveCurrentDomain (targetWindow)
	{
		if (!targetWindow || !targetWindow.location)
		{
			return '';
		}

		return normalizeString(targetWindow.location.hostname || targetWindow.location.host);
	}

	function buildResolverUrl (serviceBaseUrl, entrypoint, domain)
	{
		var normalizedEntrypoint = entrypoint === 'my-account' ? 'my-account' : 'checkout';
		var normalizedBase = serviceBaseUrl.replace(/\/+$/, '');
		var query = domain ? '?domain=' + encodeURIComponent(domain) : '';

		return normalizedBase + '/api/sca/runtime/' + normalizedEntrypoint + query;
	}

	function readString (source, path)
	{
		var current = source;
		var parts = path.split('.');
		var index = 0;
		var normalized = '';

		while (current && index < parts.length)
		{
			current = current[parts[index]];
			index++;
		}

		normalized = normalizeString(current);
		return normalized;
	}

	function runtimeMatchesPayload (runtime, payload)
	{
		var expectedVersion = readString(payload, 'runtime.version');

		return !!(runtime && typeof runtime.mount === 'function' && expectedVersion && runtime.version === expectedVersion);
	}

	function resolveRuntimeMetadata (targetWindow, metadataUrl, onResolved, onError)
	{
		if (typeof targetWindow.fetch !== 'function')
		{
			onError(new Error('window.fetch is unavailable.'));
			return;
		}

		targetWindow.fetch(metadataUrl, {
			credentials: 'omit'
		})
			.then(function (response)
			{
				if (!response.ok)
				{
					throw new Error('Runtime metadata request failed with ' + response.status);
				}

				return response.json();
			})
			.then(function (payload)
			{
				onResolved(payload || {});
			})
			.catch(function (error)
			{
				onError(error);
			});
	}

	function readRuntime (targetWindow, entrypoint)
	{
		if (!targetWindow || !targetWindow.PayStandRemote)
		{
			return null;
		}

		return targetWindow.PayStandRemote[entrypoint] || null;
	}

	function scriptElementId (scriptUrl)
	{
		return 'paystand-remote-runtime-' + scriptUrl.replace(/[^a-z0-9_-]/ig, '-');
	}

	function loadRuntimeScript (targetWindow, scriptUrl, onLoad, onError)
	{
		var documentRef = targetWindow.document;
		var existingScript = documentRef.getElementById(scriptElementId(scriptUrl));
		var scriptNode;

		if (existingScript)
		{
			if (existingScript.getAttribute('data-paystand-loaded') === 'true')
			{
				onLoad();
				return;
			}

			existingScript.addEventListener('load', onLoad);
			existingScript.addEventListener('error', function ()
			{
				onError(new Error('Loader request failed while loading remote script.'));
			});
			return;
		}

		scriptNode = documentRef.createElement('script');
		scriptNode.id = scriptElementId(scriptUrl);
		scriptNode.type = 'text/javascript';
		scriptNode.async = true;
		scriptNode.src = scriptUrl;
		scriptNode.setAttribute('data-paystand-loaded', 'false');
		scriptNode.addEventListener('load', function ()
		{
			scriptNode.setAttribute('data-paystand-loaded', 'true');
			onLoad();
		});
		scriptNode.addEventListener('error', function ()
		{
			onError(new Error('Loader request failed while loading remote script.'));
		});

		(documentRef.head || documentRef.body || documentRef.documentElement).appendChild(scriptNode);
	}

	function buildRuntimeConfig (debug, payload)
	{
		var config = {};
		var resolvedConfig = payload && payload.config && typeof payload.config === 'object' ? payload.config : null;
		var key;

		if (resolvedConfig)
		{
			for (key in resolvedConfig)
			{
				if (Object.prototype.hasOwnProperty.call(resolvedConfig, key))
				{
					config[key] = resolvedConfig[key];
				}
			}
		}

		if (typeof config.debug === 'undefined')
		{
			config.debug = debug;
		}

		return config;
	}

	function readContainerComponent (container, componentName)
	{
		if (!container || typeof container.getComponent !== 'function')
		{
			return null;
		}

		try
		{
			return container.getComponent(componentName) || null;
		}
		catch (error)
		{
			return null;
		}
	}

	function mountRuntime (targetWindow, container, entrypoint, scriptUrl, debug, payload, loaderPrint, serviceBaseUrl)
	{
		var runtime = readRuntime(targetWindow, entrypoint);

		if (!runtime || typeof runtime.mount !== 'function')
		{
			loaderPrint.error({
				eventType: 'runtime-load-failure',
				phase: 'loader',
				action: 'mount',
				status: 'error',
				message: LOADER_TOAST_MESSAGE,
				metadata: {
					entrypoint: entrypoint,
					scriptUrl: scriptUrl,
					supportReason: 'Remote runtime did not register a mount function.'
				}
			});
			return;
		}

		try
		{
			var mountResult = runtime.mount({
				container: container,
				entrypoint: entrypoint,
				loaderServiceBaseUrl: serviceBaseUrl,
				accountId: readString(payload, 'accountId'),
				domain: readString(payload, 'domain'),
				runtimeVersion: readString(payload, 'runtime.version'),
				runtimeUrl: scriptUrl,
				config: buildRuntimeConfig(debug, payload),
				plugins: payload && payload.plugins && typeof payload.plugins.length === 'number' ? payload.plugins : [],
				globals: {
					window: targetWindow,
					document: targetWindow.document,
					jQuery: targetWindow.jQuery,
					Layout: readContainerComponent(container, 'Layout'),
					Cart: readContainerComponent(container, 'Cart'),
					Checkout: readContainerComponent(container, 'Checkout'),
					Environment: readContainerComponent(container, 'Environment'),
					UserProfile: readContainerComponent(container, 'UserProfile')
				}
			});

			if (mountResult && typeof mountResult.then === 'function')
			{
				mountResult.catch(function onMountRejected (error)
				{
					loaderPrint.error({
						eventType: 'runtime-load-failure',
						phase: 'loader',
						action: 'mount',
						status: 'error',
						message: LOADER_TOAST_MESSAGE,
						error: error,
						metadata: {
							entrypoint: entrypoint,
							scriptUrl: scriptUrl,
							supportReason: 'Remote runtime mount failed.'
						}
					});
				});
			}
		}
		catch (error)
		{
			loaderPrint.error({
				eventType: 'runtime-load-failure',
				phase: 'loader',
				action: 'mount',
				status: 'error',
				message: LOADER_TOAST_MESSAGE,
				error: error,
				metadata: {
					entrypoint: entrypoint,
					scriptUrl: scriptUrl,
					supportReason: 'Remote runtime mount failed.'
				}
			});
		}
	}

	function createLoaderPrint (targetWindow, serviceBaseUrl, entrypoint, userProfile)
	{
		var sessionId = randomId();
		var flowId = randomId();
		var resolvedPayload = null;

		return {
			setResolvedPayload: function setResolvedPayload (payload)
			{
				resolvedPayload = payload && typeof payload === 'object' ? payload : null;
			},
			info: function info (event)
			{
				if (readString(event, 'eventType') === 'runtime-load-start')
				{
					clearLoaderToast(targetWindow);
				}

				emitPrint('info', event);
			},
			error: function error (event)
			{
				renderLoaderErrorToast(targetWindow, entrypoint, event);
				emitPrint('error', event);
			}
		};

		function emitPrint (level, event)
		{
			readLoaderUserContext(targetWindow, userProfile, function onUserContextResolved (userContext)
			{
				var payload = buildLoaderPrintPayload(
					targetWindow,
					entrypoint,
					sessionId,
					flowId,
					resolvedPayload,
					userContext,
					level,
					event
				);

				postLoaderPrint(targetWindow, serviceBaseUrl, payload);
				mirrorLoaderPrint(payload);
			});
		}
	}

	function readLoaderUserContext (targetWindow, userProfile, onResolved)
	{
		var fallback = readLoaderFallbackUserContext(targetWindow);
		var profileRequest = null;

		if (userProfile && typeof userProfile.getUserProfile === 'function')
		{
			try
			{
				profileRequest = userProfile.getUserProfile();
			}
			catch (error)
			{
				profileRequest = null;
			}
		}

		if (!profileRequest)
		{
			onResolved(fallback);
			return;
		}

		if (typeof profileRequest.then === 'function')
		{
			profileRequest.then(function onProfileResolved (profile)
			{
				onResolved(mergeLoaderUserContext(readLoaderUserContextFromRecord(profile, 'user-profile'), fallback));
			}, function onProfileRejected ()
			{
				onResolved(fallback);
			});
			return;
		}

		if (typeof profileRequest.done === 'function')
		{
			profileRequest.done(function onProfileResolved (profile)
			{
				onResolved(mergeLoaderUserContext(readLoaderUserContextFromRecord(profile, 'user-profile'), fallback));
			}).fail(function onProfileRejected ()
			{
				onResolved(fallback);
			});
			return;
		}

		onResolved(fallback);
	}

	function readLoaderFallbackUserContext (targetWindow)
	{
		var scProfile = null;
		var profileModelModule = targetWindow && targetWindow.ProfileModel ? targetWindow.ProfileModel : null;
		var profileModel = null;

		if (targetWindow && targetWindow.SC && targetWindow.SC.ENVIRONMENT && targetWindow.SC.ENVIRONMENT.PROFILE)
		{
			scProfile = targetWindow.SC.ENVIRONMENT.PROFILE;
		}

		if (profileModelModule && typeof profileModelModule.getInstance === 'function')
		{
			try
			{
				profileModel = profileModelModule.getInstance();
			}
			catch (error)
			{
				profileModel = null;
			}
		}

		return mergeLoaderUserContext(
			readLoaderUserContextFromRecord(readLoaderProfileModelRecord(profileModel), 'profile-model'),
			readLoaderUserContextFromRecord(scProfile, 'sc-environment-profile')
		);
	}

	function readLoaderUserContextFromRecord (record, source)
	{
		var profile = asRecord(sanitizeTelemetryValue(record));
		var nestedProfile = asRecord(profile.profile);
		var baseProfile = Object.keys(nestedProfile).length ? nestedProfile : profile;
		var userInternalId =
			readString(profile, 'userInternalId') ||
			readString(profile, 'userId') ||
			readString(baseProfile, 'internalid') ||
			readString(baseProfile, 'userInternalId') ||
			readString(baseProfile, 'userId');
		var userEmail =
			readString(profile, 'email') ||
			readString(baseProfile, 'email');
		var subsidiaryId =
			readString(profile, 'subsidiaryId') ||
			readString(baseProfile, 'subsidiary') ||
			readString(baseProfile, 'subsidiaryId');
		var isLoggedIn =
			readBooleanish(profile, 'isLoggedIn');

		if (typeof isLoggedIn === 'undefined')
		{
			isLoggedIn = readBooleanish(profile, 'isloggedin');
		}
		if (typeof isLoggedIn === 'undefined')
		{
			isLoggedIn = readBooleanish(baseProfile, 'isLoggedIn');
		}
		if (typeof isLoggedIn === 'undefined')
		{
			isLoggedIn = readBooleanish(baseProfile, 'isloggedin');
		}

		return {
			userInternalId: userInternalId,
			userEmail: userEmail,
			subsidiaryId: subsidiaryId,
			isLoggedIn: isLoggedIn,
			userContextSource: userInternalId || userEmail || subsidiaryId ? source : '',
			profile: buildLoaderProfileSnapshot(baseProfile, {
				internalid: userInternalId,
				email: userEmail,
				subsidiary: subsidiaryId,
				isLoggedIn: isLoggedIn
			})
		};
	}

	function readLoaderProfileModelRecord (profileModel)
	{
		var snapshot = {};

		if (!profileModel)
		{
			return null;
		}

		if (typeof profileModel.toJSON === 'function')
		{
			snapshot = asRecord(sanitizeTelemetryValue(profileModel.toJSON()));
		}

		if (typeof profileModel.get === 'function')
		{
			if (typeof snapshot.email === 'undefined')
			{
				snapshot.email = profileModel.get('email');
			}
			if (typeof snapshot.internalid === 'undefined')
			{
				snapshot.internalid = profileModel.get('internalid');
			}
			if (typeof snapshot.isLoggedIn === 'undefined')
			{
				snapshot.isLoggedIn = profileModel.get('isLoggedIn');
			}
			if (typeof snapshot.isloggedin === 'undefined')
			{
				snapshot.isloggedin = profileModel.get('isloggedin');
			}
			if (typeof snapshot.subsidiary === 'undefined')
			{
				snapshot.subsidiary = profileModel.get('subsidiary');
			}
		}

		return Object.keys(snapshot).length ? snapshot : null;
	}

	function mergeLoaderUserContext (primary, fallback)
	{
		var nextPrimary = primary || {};
		var nextFallback = fallback || {};

		return {
			userInternalId: nextPrimary.userInternalId || nextFallback.userInternalId || '',
			userEmail: nextPrimary.userEmail || nextFallback.userEmail || '',
			subsidiaryId: nextPrimary.subsidiaryId || nextFallback.subsidiaryId || '',
			isLoggedIn: typeof nextPrimary.isLoggedIn !== 'undefined' ? nextPrimary.isLoggedIn : nextFallback.isLoggedIn,
			userContextSource: nextPrimary.userContextSource || nextFallback.userContextSource || '',
			profile: nextPrimary.profile || nextFallback.profile || null
		};
	}

	function buildLoaderPrintPayload (targetWindow, entrypoint, sessionId, flowId, resolvedPayload, userContext, level, event)
	{
		var config = resolvedPayload && resolvedPayload.config && typeof resolvedPayload.config === 'object'
			? resolvedPayload.config
			: null;
		var metadata = event && event.metadata && typeof event.metadata === 'object'
			? cloneRecord(event.metadata)
			: {};

		if (userContext.profile && typeof metadata.profile === 'undefined')
		{
			metadata.profile = userContext.profile;
		}
		if (typeof userContext.isLoggedIn !== 'undefined' && typeof metadata.isLoggedIn === 'undefined')
		{
			metadata.isLoggedIn = userContext.isLoggedIn;
		}

		return {
			entrypoint: entrypoint,
			eventType: event && event.eventType ? event.eventType : 'runtime-load-event',
			severity: level,
			accountId: readString(resolvedPayload, 'accountId'),
			assignmentId: readString(config, 'assignmentId'),
			customerSlug: readString(config, 'customerSlug'),
			environment: readString(config, 'environment'),
			domain: resolveCurrentDomain(targetWindow),
			sessionId: sessionId,
			flowId: flowId,
			phase: event && event.phase ? event.phase : '',
			action: event && event.action ? event.action : '',
			status: event && event.status ? event.status : '',
			message: event && event.message ? event.message : '',
			stack: readLoaderStack(event),
			url: targetWindow && targetWindow.location ? normalizeString(targetWindow.location.href) : '',
			userInternalId: userContext.userInternalId || '',
			userEmail: userContext.userEmail || '',
			subsidiaryId: userContext.subsidiaryId || '',
			userContextSource: userContext.userContextSource || '',
			metadata: Object.keys(metadata).length ? metadata : undefined
		};
	}

	function postLoaderPrint (targetWindow, serviceBaseUrl, payload)
	{
		if (!serviceBaseUrl || !targetWindow || typeof targetWindow.fetch !== 'function')
		{
			return;
		}

		targetWindow.fetch(serviceBaseUrl.replace(/\/+$/, '') + '/api/sca/runtime/events', {
			method: 'POST',
			mode: 'cors',
			credentials: 'omit',
			keepalive: true,
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(payload)
		}).catch(function noop ()
		{
		});
	}

	function mirrorLoaderPrint (payload)
	{
		var consoleMethod = null;

		if (!payload || payload.environment !== 'dev' || typeof console === 'undefined')
		{
			return;
		}

		consoleMethod = payload.severity === 'error'
			? console.error
			: console.info;

		if (typeof consoleMethod === 'function')
		{
			consoleMethod.call(console, '[PaystandLoader] ' + (payload.message || payload.eventType), payload);
		}
	}

	function readLoaderStack (event)
	{
		if (!event)
		{
			return '';
		}

		if (event.stack)
		{
			return normalizeString(event.stack);
		}

		if (event.error && event.error.stack)
		{
			return normalizeString(event.error.stack);
		}

		if (event.error && event.error.message)
		{
			return normalizeString(event.error.message);
		}

		return '';
	}

	function buildLoaderProfileSnapshot (profile, defaults)
	{
		var snapshot = asRecord(sanitizeTelemetryValue(profile));
		var key;

		for (key in defaults)
		{
			if (Object.prototype.hasOwnProperty.call(defaults, key) && typeof defaults[key] !== 'undefined' && typeof snapshot[key] === 'undefined')
			{
				snapshot[key] = defaults[key];
			}
		}

		return Object.keys(snapshot).length ? snapshot : null;
	}

	function sanitizeTelemetryValue (value, depth)
	{
		var nextDepth = typeof depth === 'number' ? depth : 0;
		var normalized = null;
		var index;
		var key;

		if (nextDepth > 4 || value === null || typeof value === 'undefined')
		{
			return value;
		}

		if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')
		{
			return value;
		}

		if (Object.prototype.toString.call(value) === '[object Array]')
		{
			normalized = [];
			for (index = 0; index < value.length; index++)
			{
				normalized.push(sanitizeTelemetryValue(value[index], nextDepth + 1));
			}
			return normalized;
		}

		if (typeof value !== 'object')
		{
			return String(value);
		}

		normalized = {};
		for (key in value)
		{
			if (Object.prototype.hasOwnProperty.call(value, key))
			{
				normalized[key] = sanitizeTelemetryValue(value[key], nextDepth + 1);
			}
		}

		return normalized;
	}

	function asRecord (value)
	{
		return value && typeof value === 'object' && Object.prototype.toString.call(value) !== '[object Array]'
			? value
			: {};
	}

	function cloneRecord (record)
	{
		var nextRecord = {};
		var key;

		for (key in record)
		{
			if (Object.prototype.hasOwnProperty.call(record, key))
			{
				nextRecord[key] = record[key];
			}
		}

		return nextRecord;
	}

	function renderLoaderErrorToast (targetWindow, entrypoint, event)
	{
		var doc = targetWindow && targetWindow.document ? targetWindow.document : null;
		var message = buildLoaderToastMessage(event);
		var reason = buildLoaderSupportReason(event);
		var details = [
			buildLoaderToastDetail('Stage', buildLoaderToastStage(event), true),
			buildLoaderToastDetail('Entry', readString(event, 'metadata.entrypoint') || entrypoint, true),
			buildLoaderToastDetail('Reason', reason, false),
			buildLoaderToastDetail('Runtime', readString(event, 'metadata.scriptUrl'), true),
			buildLoaderToastDetail('Resolver', readString(event, 'metadata.resolverUrl'), true)
		];

		if (!doc || !message)
		{
			return;
		}

		showLoaderToast(doc, {
			title: LOADER_TOAST_TITLE,
			message: message,
			type: 'error',
			details: details
		});
	}

	function clearLoaderToast (targetWindow)
	{
		var doc = targetWindow && targetWindow.document ? targetWindow.document : null;
		var existing = doc ? doc.getElementById('ps-toast-container') : null;

		if (existing && existing.parentNode)
		{
			existing.parentNode.removeChild(existing);
		}
	}

	function showLoaderToast (doc, opts)
	{
		var container = null;
		var toast = null;
		var closeButton = null;
		var copyButton = null;
		var duration = typeof opts.durationMs === 'number' && opts.durationMs > 0 ? opts.durationMs : 8000;
		var timer = null;

		ensureLoaderToastStyles(doc);
		container = ensureLoaderToastContainer(doc);
		container.innerHTML = '';

		toast = doc.createElement('div');
		toast.className = 'ps-toast ps-toast--' + (opts.type || 'error');
		toast.setAttribute('role', 'alert');
		toast.setAttribute('aria-live', opts.type === 'success' || opts.type === 'notice' ? 'polite' : 'assertive');
		toast.innerHTML = buildLoaderToastHtml(opts, duration);
		container.appendChild(toast);

		closeButton = toast.querySelector('.ps-toast__close');
		if (closeButton)
		{
			closeButton.addEventListener('click', function onCloseClick ()
			{
				removeLoaderToast(toast);
			});
		}

		copyButton = toast.querySelector('.ps-toast__copy');
		if (copyButton)
		{
			copyButton.addEventListener('click', function onCopyClick ()
			{
				copyLoaderToastText(buildLoaderToastCopyText(opts), copyButton, doc);
			});
		}

		timer = setTimeout(function onToastTimeout ()
		{
			removeLoaderToast(toast);
		}, duration);

		toast.addEventListener('mouseenter', function onToastHover ()
		{
			clearTimeout(timer);
		}, { once: true });
	}

	function ensureLoaderToastContainer (doc)
	{
		var existing = doc.getElementById('ps-toast-container');
		var el = null;

		if (existing)
		{
			return existing;
		}

		el = doc.createElement('div');
		el.id = 'ps-toast-container';
		doc.body.appendChild(el);
		return el;
	}

	function ensureLoaderToastStyles (doc)
	{
		var existing = doc.getElementById('ps-loader-toast-styles');
		var style = null;

		if (existing)
		{
			return existing;
		}

		style = doc.createElement('style');
		style.id = 'ps-loader-toast-styles';
		style.type = 'text/css';
		style.textContent = ''
			+ '#ps-toast-container{position:fixed;right:1.5rem;bottom:1.5rem;z-index:99999;display:flex;flex-direction:column;gap:.75rem;width:min(380px,calc(100vw - 2rem));pointer-events:none;}'
			+ '.ps-toast{pointer-events:all;background:#fff;border-radius:10px;border-left:4px solid #dc2626;box-shadow:0 8px 28px rgba(15,23,42,.16);overflow:hidden;padding:.85rem 1rem 0;animation:ps-loader-toast-in .25s ease;}'
			+ '.ps-toast--warning{border-left-color:#d97706;}'
			+ '.ps-toast--success{border-left-color:#059669;}'
			+ '.ps-toast--notice{border-left-color:#2563eb;}'
			+ '.ps-toast__header{display:flex;align-items:center;gap:.5rem;margin-bottom:.35rem;}'
			+ '.ps-toast__icon{display:inline-flex;align-items:center;justify-content:center;width:18px;height:18px;border-radius:50%;font-size:.72rem;font-weight:700;flex-shrink:0;background:#dc2626;color:#fff;}'
			+ '.ps-toast__icon--warning{background:#d97706;}'
			+ '.ps-toast__icon--success{background:#059669;}'
			+ '.ps-toast__icon--notice{background:#2563eb;}'
			+ '.ps-toast__title{flex:1;font-weight:600;font-size:.9rem;color:#111827;}'
			+ '.ps-toast__close{margin-left:auto;padding:0;border:none;background:none;color:#9ca3af;cursor:pointer;font-size:1.1rem;line-height:1;flex-shrink:0;}'
			+ '.ps-toast__close:hover{color:#374151;}'
			+ '.ps-toast__message{margin:0 0 .5rem;color:#374151;font-size:.875rem;line-height:1.45;}'
			+ '.ps-toast__meta{display:flex;flex-direction:column;gap:.2rem;margin-bottom:.45rem;}'
			+ '.ps-toast__meta-row{display:flex;align-items:baseline;gap:.5rem;}'
			+ '.ps-toast__meta-label{width:4.5rem;flex-shrink:0;color:#6b7280;font-size:.72rem;font-weight:500;}'
			+ '.ps-toast__meta-value{color:#111827;font-size:.72rem;word-break:break-word;}'
			+ '.ps-toast__meta-value--code{font-family:monospace;}'
			+ '.ps-toast__copy{display:block;margin:0 0 .6rem;padding:0;border:none;background:none;color:#6b7280;cursor:pointer;font-size:.75rem;text-decoration:underline;}'
			+ '.ps-toast__copy:hover{color:#111827;}'
			+ '.ps-toast__copy:disabled{color:#059669;cursor:default;text-decoration:none;}'
			+ '.ps-toast__progress{height:3px;margin:0 -1rem;background:#dc2626;opacity:.32;animation:ps-loader-toast-progress linear forwards;}'
			+ '.ps-toast--warning .ps-toast__progress{background:#d97706;}'
			+ '.ps-toast--success .ps-toast__progress{background:#059669;}'
			+ '.ps-toast--notice .ps-toast__progress{background:#2563eb;}'
			+ '@keyframes ps-loader-toast-in{from{transform:translateY(12px);opacity:0;}to{transform:none;opacity:1;}}'
			+ '@keyframes ps-loader-toast-progress{from{width:100%;}to{width:0%;}}';
		doc.head.appendChild(style);
		return style;
	}

	function buildLoaderToastHtml (opts, duration)
	{
		var type = opts.type || 'error';
		var icon = loaderToastIcon(type);
		var details = normalizeLoaderToastDetails(opts.details);
		var metaSection = details.length
			? '<div class="ps-toast__meta">' + mapLoaderToastDetails(details) + '</div>'
			: '';
		var copySection = details.length
			? '<button type="button" class="ps-toast__copy">' + escapeLoaderHtml(opts.copyLabel || 'Copy for support') + '</button>'
			: '';

		return ''
			+ '<div class="ps-toast__header">'
			+ '<span class="ps-toast__icon ps-toast__icon--' + escapeLoaderHtml(type) + '" aria-hidden="true">' + escapeLoaderHtml(icon) + '</span>'
			+ '<span class="ps-toast__title">' + escapeLoaderHtml(opts.title || LOADER_TOAST_TITLE) + '</span>'
			+ '<button type="button" class="ps-toast__close" aria-label="Dismiss message">&times;</button>'
			+ '</div>'
			+ '<p class="ps-toast__message">' + escapeLoaderHtml(opts.message || LOADER_TOAST_MESSAGE) + '</p>'
			+ metaSection
			+ copySection
			+ '<div class="ps-toast__progress" style="animation-duration:' + String(duration) + 'ms"></div>';
	}

	function normalizeLoaderToastDetails (details)
	{
		var normalized = [];
		var index = 0;
		var item = null;
		var value = '';

		if (!details || typeof details.length !== 'number')
		{
			return normalized;
		}

		for (index = 0; index < details.length; index++)
		{
			item = details[index];
			value = item && item.value !== null && item.value !== undefined ? String(item.value) : '';

			if (!item || !item.label || !value)
			{
				continue;
			}

			normalized.push({
				label: String(item.label),
				value: value,
				code: item.code === true
			});
		}

		return normalized;
	}

	function mapLoaderToastDetails (details)
	{
		var html = '';
		var index = 0;
		var item = null;
		var valueClass = '';

		for (index = 0; index < details.length; index++)
		{
			item = details[index];
			valueClass = item.code ? 'ps-toast__meta-value ps-toast__meta-value--code' : 'ps-toast__meta-value';
			html += ''
				+ '<div class="ps-toast__meta-row">'
				+ '<span class="ps-toast__meta-label">' + escapeLoaderHtml(item.label) + '</span>'
				+ '<span class="' + valueClass + '">' + escapeLoaderHtml(item.value) + '</span>'
				+ '</div>';
		}

		return html;
	}

	function buildLoaderToastCopyText (opts)
	{
		var details = normalizeLoaderToastDetails(opts.details);
		var lines = [
			opts.title || LOADER_TOAST_TITLE,
			opts.message || LOADER_TOAST_MESSAGE,
			''
		];
		var index = 0;

		for (index = 0; index < details.length; index++)
		{
			lines.push(details[index].label + ': ' + details[index].value);
		}

		return lines.join('\n');
	}

	function copyLoaderToastText (text, button, doc)
	{
		if (typeof navigator !== 'undefined' && navigator.clipboard && typeof navigator.clipboard.writeText === 'function')
		{
			navigator.clipboard.writeText(text).then(function onCopySuccess ()
			{
				flashLoaderCopyButton(button);
			}).catch(function onCopyFailure () {});
			return;
		}

		try
		{
			var textArea = doc.createElement('textarea');
			textArea.value = text;
			textArea.style.position = 'fixed';
			textArea.style.opacity = '0';
			doc.body.appendChild(textArea);
			textArea.select();
			doc.execCommand('copy');
			textArea.parentNode.removeChild(textArea);
			flashLoaderCopyButton(button);
		}
		catch (error)
		{
			return;
		}
	}

	function flashLoaderCopyButton (button)
	{
		var original = button.textContent;
		button.textContent = 'Copied!';
		button.disabled = true;
		setTimeout(function onCopyReset ()
		{
			button.textContent = original;
			button.disabled = false;
		}, 2000);
	}

	function removeLoaderToast (toast)
	{
		if (!toast)
		{
			return;
		}

		toast.style.opacity = '0';
		toast.style.transform = 'translateY(8px)';
		toast.style.transition = 'opacity 0.2s ease, transform 0.2s ease';
		setTimeout(function onToastRemoved ()
		{
			if (toast.parentNode)
			{
				toast.parentNode.removeChild(toast);
			}
		}, 220);
	}

	function buildLoaderToastMessage (event)
	{
		return readString(event, 'message') || LOADER_TOAST_MESSAGE;
	}

	function buildLoaderSupportReason (event)
	{
		var supportReason = readString(event, 'metadata.supportReason');
		var errorReason = readLoaderErrorReason(event ? event.error : null);

		if (supportReason && errorReason && supportReason.toLowerCase().indexOf(errorReason.toLowerCase()) === -1)
		{
			return supportReason + ' Reason: ' + errorReason;
		}

		return supportReason || errorReason;
	}

	function buildLoaderToastStage (event)
	{
		var phase = readString(event, 'phase') || 'loader';
		var action = readString(event, 'action') || 'unknown';
		return phase + '/' + action;
	}

	function buildLoaderToastDetail (label, value, code)
	{
		return {
			label: label,
			value: value,
			code: code === true
		};
	}

	function readLoaderErrorReason (error)
	{
		if (!error)
		{
			return '';
		}

		if (typeof error === 'string')
		{
			return error;
		}

		if (typeof error.message === 'string' && error.message)
		{
			return error.message;
		}

		if (typeof error.type === 'string' && error.type)
		{
			return 'Browser reported a ' + error.type + ' error.';
		}

		try
		{
			var serialized = JSON.stringify(sanitizeTelemetryValue(error));
			return serialized && serialized !== '{}' ? serialized : '';
		}
		catch (serializationError)
		{
			return '';
		}
	}

	function loaderToastIcon (type)
	{
		if (type === 'success')
		{
			return '+';
		}

		if (type === 'notice')
		{
			return 'i';
		}

		return '!';
	}

	function escapeLoaderHtml (value)
	{
		return String(value)
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#39;');
	}

	function randomId ()
	{
		if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function')
		{
			return crypto.randomUUID();
		}

		return 'loader-' + Date.now() + '-' + Math.random().toString(16).slice(2, 10);
	}

	function readBooleanish (source, key)
	{
		var value = source && key ? source[key] : undefined;

		if (typeof value === 'boolean' || typeof value === 'string')
		{
			return value;
		}

		return undefined;
	}
});
